import { QuoteFormResponseName } from '@common/constants/formResponseNames';
import type { ProspectResponse } from '@common/types/prospects';
import type { TemplateFormField } from '@common/types/templateFormFields';
import { FormControl, FormControlLabel, Grid, Radio, RadioGroup, Typography } from '@mui/material';
import CurrencyInput from '@/components/CurrencyInput';
import { radioStyles } from './PricingInputStyles';

interface Props {
    prospect: ProspectResponse;
    quoteFormFields: TemplateFormField[];
    handleValueChange: (name: string, value: any) => any;
    readOnly: boolean;
}

export default function SalePricingInput({
    prospect,
    quoteFormFields,
    handleValueChange,
    readOnly,
}: Props) {
    const { prospectSummary } = prospect;

    return (
        <>
            <Grid item xs={6} lg={4}>
                <CurrencyInput
                    sx={{
                        pointerEvents: readOnly ? 'none' : undefined,
                    }}
                    label="Sale price"
                    fullWidth
                    allowDecimal
                    name={'purchasePrice'}
                    value={prospectSummary.purchasePrice}
                    onChange={(ev) => {
                        if (!readOnly) {
                            handleValueChange('purchasePrice', ev);
                        }
                    }}
                />
            </Grid>

            {quoteFormFields.find((field) => field.name === QuoteFormResponseName.TENANTS_LIVING)
                ?.isVisibleToUser && (
                <div>
                    <Typography variant="body1">Tenants living at the property?</Typography>
                    <FormControl>
                        <RadioGroup
                            sx={{
                                ...radioStyles,
                                pointerEvents: readOnly ? 'none' : undefined,
                            }}
                            row
                            aria-labelledby="Tenants living at the property?"
                            name="isTenantLivingInProperty"
                            value={prospectSummary.isTenantLivingInProperty}
                            onChange={(ev) => {
                                if (!readOnly) {
                                    handleValueChange('isTenantLivingInProperty', ev.target.value);
                                }
                            }}
                        >
                            <FormControlLabel value={true} control={<Radio />} label="Yes" />
                            <FormControlLabel value={false} control={<Radio />} label="No" />
                        </RadioGroup>
                    </FormControl>
                </div>
            )}
        </>
    );
}
